import type { ProductImage, ProductImageType } from 'product/types/Product'

const PANORAMIC_IMAGE = 'O2'

export const getPanoramicImage = (
	images: Partial<Record<ProductImageType, ProductImage>>
) => images[PANORAMIC_IMAGE] as ProductImage
